/*
 * @Description   : 上报钩子管理器
 * @usage         :
 * @Date          : 2022-04-22 19:43:01
 * @Author        : hadeshe93<hadeshe93@gmail.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-07 11:17:01
 * @FilePath: /app-monorepo-projects/packages/app-share/src/libs/ageis/hook-manager.ts
 */

import { EAegisLogTypes } from '@/constants/aegis';

type LogData = { logs: any, logType: EAegisLogTypes };
type BeforeRequestCallback = (data: LogData) => boolean;

// before-request 钩子的管理器
export class BeforeRequestManager {
  callbackMap = new Map<EAegisLogTypes, BeforeRequestCallback[]>();

  // 注册
  register(logType: EAegisLogTypes, callback: BeforeRequestCallback) {
    let callbacks = this.callbackMap.get(logType);
    if (!callbacks) {
      callbacks = [];
    }
    callbacks.push(callback);
    this.callbackMap.set(logType, callbacks);
  }

  // 运行
  run(data: LogData): boolean {
    let canSubmit = true;
    const { logType = '' } = data;
    if (!logType) return canSubmit;

    const callbacks = this.callbackMap.get(logType);
    if (!callbacks || callbacks.length === 0) return canSubmit;
    canSubmit = callbacks.every(cb => cb(data));

    return canSubmit;
  }
}

